/* eslint-disable */
import dayjs from 'dayjs';
import { Theme } from '@mui/material';
import { HeatmapColorSettings } from '../theme';

export enum OiTab {
  DAILY_OI = 'daily',
  INTRADAY = 'intraday',
}

export const OI_TAB_LABELS = new Map([
  [OiTab.DAILY_OI, 'Daily Open Interest'],
  [OiTab.INTRADAY, 'Intraday OI + Gamma'],
]);

export enum ProcessingState {
  LOADING = 'loading',
  FAILED_FETCH = 'failed_fetch',
  DONE = 'done',
}

export const PRICE_BOUNDS = [
  0.001, 0.002, 0.003, 0.004, 0.005, 0.01, 0.02, 0.03, 0.04,
].reverse(); // reverse to ensure that a higher zoom value on the slider leads to a higher zoom,
// instead of a lower val meaning higher zoom

export const STRIKE_ZOOM_BOUNDS = [
  0, 0.2, 0.35, 0.5, 0.65, 0.8, 0.9, 0.935, 0.97,
];

export type PriceCandleWithDateTime = {
  datetime: dayjs.Dayjs;
} & PriceCandle;

export type PriceCandle = {
  time: number; // in seconds
  open: number;
  high: number;
  low: number;
  close: number;
};

export type TraceSettings = {
  zoom?: number;
  posColor?: string | null;
  negColor?: string | null;
  posStrikeColor?: string | null;
  negStrikeColor?: string | null;
  contourLineColor?: string | null;
  putColor?: string | null;
  callColor?: string | null;
  hiroColor?: string | null;
  upCandleFill?: string | null;
  downCandleFill?: string | null;
  upCandleLineColor?: string | null;
  downCandleLineColor?: string | null;
  candleDuration?: number;
  selectedLense?: TraceLense;
  hideLevels?: boolean;
  scaleRange?: OIScaleRange;
  showGexZeroDte?: boolean;
  hiroSyms?: any;
  strikeBarType?: TraceStrikeBarType;
  hideColorScale?: boolean;
  hideContourLines?: boolean;
  statsLookbackDays?: number;
  useWhiteMode?: boolean;
  strikeBarsTrackerDisabled?: boolean;
  customColorsPerLense?: any;
  strikeZoom?: number;
};

export enum TraceLense {
  DELTA_END_DIFF = 0,
  GAMMA = 1,
  GAMMA_DIRECTIONAL = 2,
  GAMMA_COLOR = 3,
  DELTA = 4,
  DELTA_DIRECTIONAL = 5,
  DELTA_CHARM_DIRECTIONAL = 6,
}

export enum OIEntity {
  CUST = 'cust',
  PROCUST = 'procust',
  MARKET_MAKER = 'mm',
  FIRM = 'firm',
  BD = 'bd',
}

export enum OIScaleRange {
  AUTO = 'auto',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum TraceStrikeBarType {
  GAMMA = 'gamma',
  OI = 'oi',
  OI_NET = 'oi_net',
  NONE = 'none',
}

export type ZoomData = {
  x?: string[];
  y?: number[];
  y2?: number[];
};

export enum TraceGreek {
  Gamma = 'gamma',
  Delta = 'delta',
}

export type TraceContourData = {
  chartData: any;
  firstChartTimestamp: number;
  lastChartTimestamp: number;
  latestTimestamp: number;
};

export type StrikeBarsDailyTrackerEntry = {
  dailyMin?: number;
  dailyMax?: number;
  last?: number;
  thirtyMin?: number;
  hour?: number;
};

export type StrikeBarsDailyTracker = {
  entriesPerTrace: Map<string, Map<number, StrikeBarsDailyTrackerEntry>>; // traceName => map<strike, entry>
  type: TraceStrikeBarType;
  latestTimestamp: number;
  zeroDte: boolean;
};

export type StrikeBarsData = {
  latestTimestamp: number;
  trackerData: any[];
  chartData: any[];
  annotations: any[];
};

export type TraceParams = {
  intradayDate: dayjs.Dayjs;
  intradaySym: string;
  selectedGreek: TraceGreek;
  selectedLense: TraceLense;
  selectedTheme: Theme;
  heatmapColorSettings: HeatmapColorSettings;
};
